import { observer } from 'mobx-react';
import { localeStore } from '~/mobx/localesStore';
import { modalStore } from '~/mobx/modalStore';
import { LoadingStatus } from '~/types/main';
import { scrollToElement } from '~/utils/helpers';
import { leaveWithoutSaving } from '~/utils/modalConfirmations';
import { ProfilesLazyList, TProfile } from '~/view/containers/ProfilesList';
import { branchesWorkingHoursStore } from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/store/branchesWorkingHoursStore';
import { TBranchProfile } from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/types';

const HoursProfileList = observer(() => {
  const { pagination, profilesList, selectedProfileId } = branchesWorkingHoursStore;

  const handleSelectProfile = (profile: TProfile) => {
    if (branchesWorkingHoursStore.isDataUnsaved) {
      leaveWithoutSaving({
        onConfirm: () => {
          branchesWorkingHoursStore.setProfileId(profile.id);
          branchesWorkingHoursStore.setUnsavedFlag(false);
        },
      });
    } else {
      branchesWorkingHoursStore.getProfile(profile.id);
    }
  };

  const handleNewProfile = async () => {
    const profileId = await branchesWorkingHoursStore.createProfile();
    if (profileId) scrollToElement({ id: `profile_${profileId}` });
  };

  const handleUpdateName = async (profile: TProfile) => {
    if (profile.name.length > 64) {
      modalStore.openErrorModal({
        message: localeStore.t('rename'),
      });
      return false;
    }
    const isUpdated = await branchesWorkingHoursStore.updateProfileName(profile.name);

    return isUpdated;
  };

  return (
    <ProfilesLazyList<TBranchProfile>
      onAddProfile={handleNewProfile}
      pages={pagination.pages}
      list={profilesList}
      fetch={branchesWorkingHoursStore.getProfiles}
      last_page={pagination.last_page}
      current_page={pagination.current_page}
      loading={branchesWorkingHoursStore.loadingStatus === LoadingStatus.Refreshing}
      selectedProfileId={selectedProfileId}
      selectProfile={handleSelectProfile}
      onUpdateName={handleUpdateName}
    />
  );
});

export default HoursProfileList;
